import { useCallback, useEffect, useState } from "react";
import { FaImage } from "react-icons/fa";
// import { TbClockHour4 } from "react-icons/tb";
import { Link } from "react-router-dom";
// import { apiOnlineURL, offlineApiFileURL } from "../constantes/apiFile.const";

export function LazyImage({ service }) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const [imageUrl, setimageUrl] = useState(null);

  // Construction sécurisée de l'URL de l'image
  const getImageUrl = useCallback(() => {
    if (!service.imageUrl) return null;

    // Si l'URL est déjà une URL complète, on l'utilise directement
    if (service.imageUrl.startsWith("http")) {
      return service.imageUrl;
    }

    // Sinon, on construit l'URL avec la base

    return `${
      process.env.REACT_APP_ENV === "development"
        ? process.env.REACT_APP_DEV_SERVICE_IMG
        : process.env.REACT_APP_API_SERVICE_IMG
    }/${service.imageUrl}`;
  }, [service]);

  useEffect(() => {
    const image_url = getImageUrl();
    // console.log({ image_url, error });

    if (image_url) {
      setError(false);
      setimageUrl(image_url);
    } else {
      setError(true);
    }
  }, [service, getImageUrl]);

  return (
    <div className="bg-img_background h-40 flex items-center justify-center relative overflow-hidden">
      {!loaded && !error && (
        <span className="absolute text-gray-400 text-sm z-10 flex flex-col items-center">
          <FaImage className="h-8 w-8 mb-1" />
          Chargement…
        </span>
      )}

      {imageUrl && !error ? (
        <img
          src={imageUrl}
          alt={`image-${service.nom || "service"}`}
          loading="lazy"
          className={`w-full h-40 object-cover transition-opacity duration-500 ${
            loaded ? "opacity-100" : "opacity-0"
          }`}
          onLoad={() => setLoaded(true)}
          onError={() => {
            // console.error("Erreur de chargement de l'image:", imageUrl);
            setError(true);
          }}
        />
      ) : (
        <span className="text-gray-400 text-sm flex flex-col items-center">
          <FaImage className="h-8 w-8 mb-1" />
          Image non disponible
          {/* <p>{imageUrl}</p> */}
        </span>
      )}
    </div>
  );
}

function ServiceCard({ service }) {
  return (
    <div className="flex flex-col h-[400px] bg-white shadow-md overflow-hidden group transition-all duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg">
      {/* Image - hauteur fixe */}
      <div className="flex-shrink-0 h-40">
        <LazyImage service={service} />
      </div>

      {/* Contenu - hauteur calculée (450px - 160px d'image - 32px de padding) */}
      <div className="flex flex-col h-[258px] p-4">
        {/* En-tête avec catégorie et prix */}
        <div className="flex justify-between items-center mb-2 flex-shrink-0">
          <span className="bg-gray-100 font-poppins font-medium text-[15px] text-[#444] px-2 py-1">
            {service.category?.name || "Non catégorisé"}
          </span>
          <span className="font-poppins font-bold text-[16px] text-[#111]">
            {service.price} FCFA
          </span>
        </div>

        {/* Titre et description - Zone avec hauteur fixe et scrollable */}
        <div className="flex-1 overflow-hidden mb-2">
          <div className="h-full overflow-y-auto pr-1">
            {/* Style de scrollbar personnalisé avec Tailwind */}
            <style jsx>{`
              div::-webkit-scrollbar {
                width: 3px;
              }
              div::-webkit-scrollbar-track {
                background: #f3f4f6;
                border-radius: 2px;
              }
              div::-webkit-scrollbar-thumb {
                background: #d1d5db;
                border-radius: 2px;
              }
              div::-webkit-scrollbar-thumb:hover {
                background: #9ca3af;
              }
            `}</style>

            <h3 className="font-poppins font-semibold text-[16px] text-[#222] mb-2">
              {service.nom}
            </h3>
            <p className="font-nunito text-[14px] text-[#333] leading-relaxed pr-1">
              {service.description}
            </p>
          </div>
        </div>

        {/* Bouton de réservation - toujours en bas */}
        <div className="pt-2 flex-shrink-0">
          <Link
            to={`/service/${service.id}`}
            className="block w-full text-center bg-[#FF4081] text-white py-2 px-4 hover:bg-[#FF4081]/90 transition-colors duration-200 font-nunito font-semibold text-[14px]"
            title={`Réserver ${service.nom}`}
          >
            Réserver
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ServiceCard;

// import { useCallback, useEffect, useState } from "react";
// import { FaImage } from "react-icons/fa";
// // import { TbClockHour4 } from "react-icons/tb";
// import { Link } from "react-router-dom";
// // import { apiOnlineURL, offlineApiFileURL } from "../constantes/apiFile.const";

// export function LazyImage({ service }) {
//   const [loaded, setLoaded] = useState(false);
//   const [error, setError] = useState(false);
//   const [imageUrl, setimageUrl] = useState(null);

//   // Construction sécurisée de l'URL de l'image
//   const getImageUrl = useCallback(() => {
//     if (!service.imageUrl) return null;

//     // Si l'URL est déjà une URL complète, on l'utilise directement
//     if (service.imageUrl.startsWith("http")) {
//       return service.imageUrl;
//     }

//     // Sinon, on construit l'URL avec la base

//     return `${
//       process.env.REACT_APP_ENV === "development"
//         ? process.env.REACT_APP_DEV_SERVICE_IMG
//         : process.env.REACT_APP_API_SERVICE_IMG
//     }/${service.imageUrl}`;
//   }, [service]);

//   useEffect(() => {
//     const image_url = getImageUrl();
//     // console.log({ image_url, error });

//     if (image_url) {
//       setError(false);
//       setimageUrl(image_url);
//     } else {
//       setError(true);
//     }
//   }, [service, getImageUrl]);

//   return (
//     <div className="bg-img_background h-40 flex items-center justify-center relative overflow-hidden">
//       {!loaded && !error && (
//         <span className="absolute text-gray-400 text-sm z-10 flex flex-col items-center">
//           <FaImage className="h-8 w-8 mb-1" />
//           Chargement…
//         </span>
//       )}

//       {imageUrl && !error ? (
//         <img
//           src={imageUrl}
//           alt={`image-${service.nom || "service"}`}
//           loading="lazy"
//           className={`w-full h-40 object-cover transition-opacity duration-500 ${
//             loaded ? "opacity-100" : "opacity-0"
//           }`}
//           onLoad={() => setLoaded(true)}
//           onError={() => {
//             // console.error("Erreur de chargement de l'image:", imageUrl);
//             setError(true);
//           }}
//         />
//       ) : (
//         <span className="text-gray-400 text-sm flex flex-col items-center">
//           <FaImage className="h-8 w-8 mb-1" />
//           Image non disponible
//           {/* <p>{imageUrl}</p> */}
//         </span>
//       )}
//     </div>
//   );
// }

// function ServiceCard({ service }) {
//   return (
//     <div className="flex flex-col h-96 bg-white shadow-md overflow-hidden group transition-all duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg">
//       {/* Image */}
//       <div className="flex-shrink-0">
//         <LazyImage service={service} />
//       </div>

//       {/* Contenu avec hauteur fixe et défilement si nécessaire */}
//       <div className="flex flex-col flex-grow p-4">
//         {/* En-tête avec catégorie et prix */}
//         <div className="flex justify-between items-center mb-2">
//           <span className="bg-gray-100 font-poppins font-medium text-[15px] text-[#444] px-2 py-1">
//             {service.category?.name || "Non catégorisé"}
//           </span>
//           <span className="font-poppins font-bold text-[16px] text-[#111]">
//             {service.price} FCFA
//           </span>
//         </div>

//         {/* Titre et description */}
//         <div>
//           <h3 className="font-poppins font-semibold text-[18px] text-[#222] mb-2 line-clamp-2">
//             {service.nom}
//           </h3>
//           <p className="font-nunito text-[14px] text-[#333] mb-3 line-clamp-3 flex-grow">
//             {service.description}
//           </p>
//         </div>

//         {/* Durée */}
//         {/* {service.durationMinutes ? (
//           <div className="flex items-center gap-1 font-nunito text-[14px] text-[#333] mb-4">
//             <TbClockHour4 className="flex-shrink-0" />
//             <span>
//               {service.durationMinutes} min
//               {service.durationMinutes > 1 ? "s" : ""}
//             </span>
//           </div>
//         ) : null} */}

//         {/* Bouton de réservation - toujours en bas */}
//         <div className="mt-auto pt-2">
//           <Link
//             to={`/service/${service.id}`}
//             className="block w-full text-center bg-[#FF4081] text-white py-2 px-4 hover:bg-[#FF4081]/90 transition-colors duration-200 font-nunito font-semibold text-[14px]"
//             title={`Réserver ${service.nom}`}
//           >
//             Réserver
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ServiceCard;
